import { render, staticRenderFns } from "./CaseFullDimensionalData.vue?vue&type=template&id=e46d6dd2"
import script from "./CaseFullDimensionalData.vue?vue&type=script&lang=js"
export * from "./CaseFullDimensionalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports